<template>
    <button
        type="button"
        :class="buttonClasses"
        :disabled="disabled"
        :aria-label="ariaLabel"
        @click="$emit('click', $event)"
    >
        <svg-icon :icon="icon" :width="iconSize" :height="iconSize" />
    </button>
</template>

<script>
'use strict';

const PILL_BASE =
    'inline-flex items-center justify-center rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-40 focus:outline-none focus-visible:ring-2 focus-visible:ring-theme-accent focus-visible:ring-offset-2';

const PILL_SIZE = 'h-[30px] w-[30px]';
// The panel's toolbar and the list rows sit inside a phone sheet, where a
// pill this small is under the 44px a thumb needs.
const PILL_SIZE_TOUCH = 'h-11 w-11 md:h-[30px] md:w-[30px]';

const VARIANT_COLORS = {
    accent: 'text-theme-accent hover:bg-theme-accent-bg hover:text-theme-accent',
    neutral: 'text-theme-icon hover:bg-theme-accent-bg hover:text-theme-accent',
    muted: 'text-theme-toolbar-icon hover:bg-theme-accent-bg hover:text-theme-accent',
    danger: 'text-theme-toolbar-icon hover:bg-theme-danger-bg hover:text-theme-danger',
};

export default {
    name: 'PillIconButton',
    props: {
        icon: {
            type: String,
            required: true,
        },
        ariaLabel: {
            type: String,
            required: true,
        },
        variant: {
            type: String,
            default: 'neutral',
            validator: value => ['accent', 'neutral', 'muted', 'danger'].includes(value),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        iconSize: {
            type: [String, Number],
            default: 22,
        },
        touchTarget: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click'],
    computed: {
        buttonClasses() {
            const size = this.touchTarget ? PILL_SIZE_TOUCH : PILL_SIZE;
            return `${PILL_BASE} ${size} ${VARIANT_COLORS[this.variant]}`;
        },
    },
};
</script>
